import {
    Component,
    ElementRef,
    EventEmitter, forwardRef, Inject,
    Input,
    OnInit,
    Output,
    QueryList,
    ViewChild,
    ViewChildren
} from '@angular/core';
import {QuestionInfo, QuestionInfoChatItem} from '../../model/question.model';
import {BehaviorSubject} from 'rxjs';
import {equals} from '../../util';
import {InputDirective} from '../../input/input.directive';
import {Router} from "@angular/router";
import {ChatFrameService} from "../../service/chatFrame.service";
import {FIELD_TYPES} from "../../config/fieldTypes.config";
import {UserAnswerMode, UserAnswerStateMode} from "../../model/user-answer.mode";
import {ChatQuestionsService} from "../../service/chat/chat-questions.service";
import {DATA_MASKS} from "../../config/dataMasks.config";
import {ChatService} from "../chat.service";
import {QuizComponent} from "../quiz/quiz.component";

const easeInCubic = function (t) {
    return t * t * t;
};
const easeInQuad = function (t) {
    return t * t;
};
const linear = function (t) {
    return t;
};

const scrollToBottom = (element, startTime, currentTime, duration, scrollEndElemTop, startScrollOffset) => {
    //return false;
    const runtime = currentTime - startTime;
    let progress = runtime / duration;

    progress = Math.min(progress, 1);

    const ease = easeInCubic(progress);

    element.scroll(0, startScrollOffset + (scrollEndElemTop * ease));

    if (runtime < duration) {
        requestAnimationFrame((timestamp) => {
            const currentTime = timestamp || new Date().getTime();
            scrollToBottom(element, startTime, currentTime, duration, scrollEndElemTop, startScrollOffset);
        });
    }
};

@Component({
    selector: 'app-chat',
    templateUrl: './chat.component.html',
    styleUrls: ['./chat.component.scss'],
    host: {'class': 'app-chat'}
})
export class ChatComponent implements OnInit {
    _questions = new BehaviorSubject<(QuestionInfo & QuestionInfoChatItem )[]>([]);

    @ViewChild('chatList', {static: false}) chat: ElementRef;
    @ViewChildren('chatMessage') chatMessages: QueryList<ElementRef>;

    @ViewChild(InputDirective, {static: false}) input: InputDirective;

    mouseEvent: any;

    @Output()
    editing = new EventEmitter<boolean>();


    @Output()
    hideEditing = new EventEmitter<boolean>();

    @Input()
    answerStatus: number = 0;

    @Input()
    questionsTotal: number = 0;

    @Input()
    nextBlock: any = '';

    @Input()
    message: any = '';

    @Input()
    groupEnd: any = {
        status: false,
        message: ''
    };

    @Input()
    avatar: any = '';

    @Input()
    progress: number = 0;

    @Input()
    set questions(value: QuestionInfo[]) {
        // if (value && !equals(value, this._questions.value)) {

            value.forEach(el => {
                if (el.answerList) {
                    el.answerList.forEach(listItem => {
                        listItem.answer = listItem.title;
                        listItem.fieldType = FIELD_TYPES.textList;
                        listItem.questionId = el.questionId;
                    });
                }
            });


            this._questions.next(value);

        // }
    }

    @Output()
    onEditEnded = new EventEmitter<UserAnswerStateMode>();

    answeredQuestions = [];
    activeQuestion;

    FIELDS_TYPES = FIELD_TYPES;
    DATA_MASKS = DATA_MASKS;

    popupMessage = {
        message: '',
        show: false,
        success: false,
        data: {},
        agreement: false,
    }

    constructor(private router: Router,
                private chatFrameService: ChatFrameService,
                private chatService: ChatService,
                private chatQuestionsService: ChatQuestionsService,
                @Inject(forwardRef(() => QuizComponent)) private _parent: QuizComponent,
                private elRef: ElementRef) {
    }

    ngOnInit() {
        console.log(this.nextBlock);
        
        this.chatFrameService.increaseFrameHeight();
    }

    trackById(index, item: QuestionInfo) {
        if (item.answer) {
            return item.questionId;
        }
    }

    showEdit(question: (QuestionInfoChatItem & QuestionInfo)) {
        // (document.querySelector('.scrolled') as HTMLElement).style.overflow = 'hidden';
        let parentQuestion = this._questions.value.find(el => el.questionId === question.questionId);

        if (parentQuestion && parentQuestion.answerElement || parentQuestion && question.isElementsGroup) {
            parentQuestion = null;
        }

        if (question.selected === undefined) {
            question.selected = true;
            if (parentQuestion) {
                parentQuestion.selected = true;
            }

        } else {
            question.selected = !question.selected;
            if (parentQuestion) {
                parentQuestion.selected = question.selected;
            }
        }
        // if (!question.selected) {
        //     question.editing = false;
        //     if (parentQuestion) {
        //         parentQuestion.editing = false;
        //     }
        // }
        this.editing.emit(true);


        document.addEventListener('click', (e) => {
            if ((<HTMLElement>e.target).classList.contains('chat-item')
              || (<HTMLElement>e.target).classList.contains('chat-item__message')
              || (<HTMLElement>e.target).classList.contains('user')
              || (<HTMLElement>e.target).classList.contains('progress')) {
                question.selected = false;
                question.editing = false;
                if (parentQuestion) {
                    parentQuestion.selected = false;
                    parentQuestion.editing = false;
                }
                this.editing.emit(false);
            }
        })
    }

    getAnswer(q: QuestionInfo) {
        if (q.choices) {
            return q.choices.find(value => value.value == q.answer).label;
        } else if (q.fieldType == "DATE_RANGE") {
            const value = JSON.parse(q.answer);
            return value.dateStart + ' - ' + value.dateEnd;
        } else if (q.answer && q.fieldType == "DATE_RANGE" && q.answer.includes('dateStart')) {
            const value = JSON.parse(q.answer);
            return value.dateStart + ' - ' + value.dateEnd;
        }

        const hasFieldTitle = q.fieldTitle && q.fieldType === FIELD_TYPES.text;

        if (q.fieldType === FIELD_TYPES.number) {
            // let splitString: any = this.funkyStringSplit(String(q.answer).replace(/\s/g, ''));
            // splitString = splitString.join(' ');
            // splitString = q.fieldTitle ? splitString + ' ' + q.fieldTitle : splitString;
            // return splitString;
            return q.answer;
        }

        return hasFieldTitle ? q.answer + ' ' + q.fieldTitle : q.answer;
    }

    startEdit(q: (QuestionInfoChatItem & QuestionInfo), index: any) {
        let parentQuestion = this._questions.value.find(el => el.questionId === q.questionId);

        if (parentQuestion && parentQuestion.answerElement || parentQuestion && q.isElementsGroup) {
            parentQuestion = null;
        }
        //
        // if (q.editing === undefined) {
            q.editing = true;
            if (parentQuestion) {
                parentQuestion.editing = true;
            }
        // } else {
        //     q.editing = !q.editing;
        //     if (parentQuestion) {
        //         parentQuestion.editing = !parentQuestion.editing;
        //     }
        // }
        // q.selected = !!q.selected;
        // if (parentQuestion) {
        //     parentQuestion.selected = !!parentQuestion.selected;
        // }
        this.editing.emit(q.editing);

        const editedMessage = ((this.chatMessages.toArray() as Array<any>)[index] as ElementRef).nativeElement;

        // console.log(editedMessage, ((this.chatMessages.toArray() as Array<any>)[index] as ElementRef));
        const anim = requestAnimationFrame((timestamp) => {
            const stamp = timestamp || new Date().getTime();
            const duration = 750;
            const start = stamp;

            const startScrollOffset = this.elRef.nativeElement.scrollTop;
            const scrollEndElemTop = editedMessage.offsetTop - editedMessage.offsetHeight;

            scrollToBottom(this.elRef.nativeElement, start, stamp, duration, 0, editedMessage.offsetTop - 88);
        });

        document.addEventListener('click', (e) => {
            if ((<HTMLElement>e.target).classList.contains('chat-item')
                || (<HTMLElement>e.target).classList.contains('chat-item__message--hidden')
                || (<HTMLElement>e.target).classList.contains('user')
                || (<HTMLElement>e.target).classList.contains('progress')) {
                q.editing = false;
                q.selected = false;
                if (parentQuestion) {
                    parentQuestion.selected = false;
                    parentQuestion.editing = false;
                }
                this.editing.emit(false);
            }
        })
    }

    endEditing(question: (QuestionInfoChatItem & QuestionInfo)) {
        const parentQuestion = this._questions.value.find(el => el.questionId === question.questionId);

        question.editing = false;
        question.selected = false;
        if (parentQuestion) {
            parentQuestion.selected = false;
            parentQuestion.editing = false;
        }
        this.editing.emit(false);
    }

    removeItem(item) {
        this.popupMessage.data = item;
        this.popupMessage.message = 'Are you sure you want to delete this item?';
        this.popupMessage.show = true;
        this.popupMessage.agreement = true;
    }

    isAnyOnEditing() {
        return this._questions.value.some(j => j.editing);
    }

    isAnyOnSelecting() {
        return this._questions.value.some(j => j.selected);
    }

    getQuestionTime(q: QuestionInfo & QuestionInfoChatItem) {

    }

    getAnswerTime(q: QuestionInfo & QuestionInfoChatItem) {

    }

    onQuestionAnswered(q: QuestionInfo & QuestionInfoChatItem, event) {
        q.hasAnswer = event;
    }

    saveAnswer(q: QuestionInfo & QuestionInfoChatItem) {
        const newAnswer = this.input.inputComponentRef.instance.answer;
        if (newAnswer !== '' && newAnswer !== '0') {
            const answer = this.chatQuestionsService.generateAnswer(q, newAnswer, true);
            this.onEditEnded.emit(answer);
            this.editing.emit(false);
        }

        this.endEditing(q);
    }

    nextStep(){
        this.router.navigate(['/chat/' + this.nextBlock]);
    }

    isAnswerDollarFieldType(fieldType) {
        return fieldType === FIELD_TYPES.dollar;
    }

    isAnswerNumberFieldType(fieldType) {
        return fieldType === FIELD_TYPES.number;
    }

    isAnswerPhoneFieldType(fieldType) {
        return fieldType === FIELD_TYPES.phone;
    }

    isAnswerDateFieldType(fieldType) {
        return fieldType === FIELD_TYPES.date
    }

    isAnswerSelectFieldType(fieldType) {
        return fieldType === FIELD_TYPES.select
    }

    isAnswerTextFieldType(fieldType) {
        return fieldType !== FIELD_TYPES.dollar && fieldType !== FIELD_TYPES.date && fieldType !== FIELD_TYPES.phone && fieldType !== FIELD_TYPES.number;
    }

    funkyStringSplit(s) {
        var i = s.length % 3;
        var parts = i ? [ s.substr( 0, i ) ] : [];
        for( ; i < s.length ; i += 3 )
        {
            parts.push( s.substr( i, 3 ) );
        }
        return parts;
    }

    test() {
        // console.log('next', this.nextBlock, this.questionsTotal, this.groupEnd)
        // console.log('questions', this._questions)
    }

    onConfirmPopup(item) {
        this.chatService.removeAnswer(item.id).subscribe(rez => {
            if (rez['status']) {
                const parentQuestion = this._questions.value.find(el => el.questionId === item.questionId);
                const index = parentQuestion.answerList.findIndex(listItem => listItem.id === item.id);
                parentQuestion.answerList.splice(index, 1);
                this._parent.showSuccessPopup(rez['message']);
            } else {
                this._parent.showErrorPopup(rez['message']);
            }
            this.endEditing(item);
        }, () => {
            this._parent.showErrorPopup('Sorry there was an error try again later.');
        });
    }

    closePopup() {
        this.popupMessage.show = false;
        setTimeout(() => {
          this.popupMessage.data = {};
          this.popupMessage.message = '';
          this.popupMessage.agreement = false;
        }, 500);
    }
}
